import React from "react";
import { useLocation, useNavigate } from "react-router";
import topImg from "../../Img/jobDetail/topBackground.png";
import icon from "../../Img/submission/icon.png";
import iconWhite from "../../Img/submission/icon_white.png";
import styles from "./Submission.module.css";
const Submission = ({ isDarkMode }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const job = location?.state;
  const onClick = (e) => {
    e.preventDefault();
    navigate("/", { replace: true });
  };
  return (
    <div className={styles.container}>
      <div className={styles.textContainer}>
        <img
          src={!isDarkMode ? icon : iconWhite}
          alt=""
          className={styles.icon}
        />
        <div className={!isDarkMode ? styles.first : styles.dark_first}>
          {job?.lo === "en"
            ? "Your application has been successfully submitted."
            : "지원서 제출이 완료 되었습니다."}
        </div>
        <div className={!isDarkMode ? styles.second : styles.dark_second}>
          {job?.lo === "en"
            ? "We aim to inform you of a decision on your application within two weeks."
            : "지원 결과는 작성해 주신 이메일로 2주 안에 알려드릴 예정입니다."}
        </div>
        <div className={!isDarkMode ? styles.third : styles.dark_third}>
          {job?.lo === "en" ? "Inquiries" : "채용 문의"} :{" "}
          <a href="mailto:people@mondayoff.me" target="_blank" rel="noreferrer">
            people@mondayoff.me
          </a>
        </div>
        <button className={styles.homeBtn} onClick={onClick}>
          {job?.lo === "en" ? "Home" : "홈으로 가기"}
        </button>
      </div>
    </div>
  );
};

export default Submission;
